// import React from "react";
// import Navbar from "../Navbar/Navbar";
// import { Outlet } from "react-router-dom";

// const Layout = () => {
//   return (
//     <div>
//       <Navbar />
//       <main>
//         <Outlet /> {/* This will render the page content */}
//       </main>
//     </div>
//   );
// };

// export default Layout;



// src/components/Layout/Layout.jsx

import React from "react";
import Navbar from "../Navbar/Navbar";
import { Outlet } from "react-router-dom";
import "./Layout.css";

export default function Layout() {
  return (
    <div className="layout-wrapper">
      <Navbar />
      <main className="layout-content">
        <Outlet />
      </main>
    </div>
  );
}
